import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexGrow: 1
    }
});
export default stylesheet;
